import { createAsyncThunk } from '@reduxjs/toolkit';

import { JsonQuery, type TJsonQuery } from '@/packages/JsonQuery';

import { type TThunkApi } from '@/microfrontends/filters/shared/store';

import { updateMeta } from './updateMeta';

export const switchNewMoscowDistrict = createAsyncThunk<TJsonQuery, boolean | null, TThunkApi>(
  'districtsPopup/switchNewMoscowDistrict',
  async (includeNewMoscow, thunkApi) => {
    const { getState, dispatch } = thunkApi;
    const state = getState();

    const nextJsonQuery = new JsonQuery(state.districtsPopup.jsonQuery);

    nextJsonQuery.setIncludeNewMoscow(includeNewMoscow);

    const nextJsonQuerySerialized = nextJsonQuery.toJSON();

    // специально не блокируемся об получение мета
    dispatch(updateMeta(nextJsonQuerySerialized));

    return nextJsonQuerySerialized;
  },
);
